import { render } from "./footertop-u4.vue?vue&type=template&id=5bd09aaa&scoped=true"
import script from "./footertop-u4.vue?vue&type=script&lang=js"
export * from "./footertop-u4.vue?vue&type=script&lang=js"

import "./footertop-u4.vue?vue&type=style&index=0&id=5bd09aaa&scoped=true&lang=css"

import exportComponent from "../../../../../../../usr/local/lib/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bd09aaa"]])

export default __exports__